import type { WizardState } from "../types";

/**
 * Returns true when the current wizard route needs in-memory state that was lost
 * (e.g. after a full page refresh) and the user should restart from Upload.
 */
export function wizardRequiresUpload(
  suffix: string,
  state: WizardState,
  isCommitting: boolean,
): boolean {
  if (suffix === "" || suffix === "/") return false;
  if (suffix === "/map") return state.preview === null;
  if (suffix === "/review") {
    return state.preview === null || state.importResult === null;
  }
  if (suffix === "/errors") return state.importResult === null;
  if (suffix === "/results") {
    return state.importResult === null && !isCommitting;
  }
  return false;
}
